import {
  ANI_ROUTER,
  DATE_RANGE_ROUTER,
  DNIS_ROUTER,
  HUNT_GROUP,
  MATCH_START,
  NUMBER_PLAN,
  PLAY,
  PLUGIN,
  QUEUE,
  REMOTE,
  ROUTE_START,
  SAY,
  SCRIPT,
  SIP,
  SIP_GATEWAY,
  TEAM,
  TIME_RANGE_ROUTER,
  ZONE_ROUTER,
  VOICEMAIL,
} from "callable-data-objects";
import { CreateDeviceProp } from "Providers/types";
import React, { Fragment } from "react";
import {
  Button,
  Container,
  Grid,
  Header,
  Icon,
  Segment,
} from "semantic-ui-react";

type DeviceTypesProps = {
  select: Function;
  createDevice: CreateDeviceProp | undefined;
};

const DeviceTypes = ({ select, createDevice }: DeviceTypesProps) => {
  const hasFlow = () => {
    return createDevice?.deviceType === "flow";
  };

  return (
    <Container>
      {hasFlow() && (
        <Fragment>
          <Segment>
            <Header as='h3'>Flows</Header>
          </Segment>
          <Grid stackable columns={2}>
            <Grid.Column>
              <Segment placeholder>
                <Header as='h3' icon textAlign='center'>
                  <Icon
                    color='green'
                    name='arrow alternate circle right'
                    circular
                    // style={{ color: "#434bd9" }}
                  />
                  <Header.Content>Inbound Flow</Header.Content>
                  <Header.Subheader>
                    Assign inbound numbers to the start of a flow
                  </Header.Subheader>
                </Header>
                <Button inverted secondary onClick={() => select(ROUTE_START)}>
                  Add
                </Button>
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Segment placeholder>
                <Header as='h3' icon textAlign='center'>
                  <Icon
                    color='green'
                    name='arrow alternate circle left'
                    circular
                    // style={{ color: "#434bd9" }}
                  />
                  <Header.Content>Outbound Flow</Header.Content>
                  <Header.Subheader>
                    Hook into the outbound call flow
                  </Header.Subheader>
                </Header>
                <Button inverted secondary onClick={() => select(MATCH_START)}>
                  Add
                </Button>
              </Segment>
            </Grid.Column>
          </Grid>
        </Fragment>
      )}
      <Fragment>
        <Segment>
          <Header as='h3'>Feedback</Header>
        </Segment>
        <Grid stackable columns={2}>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='purple'
                  name='bullhorn'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Play</Header.Content>
                <Header.Subheader>
                  Play back an MP3 or WAV file to the caller
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(PLAY)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='purple'
                  name='bullhorn'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Say</Header.Content>
                <Header.Subheader>
                  Play Synthesised text to the caller.
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(SAY)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
        </Grid>

        <Segment>
          <Header as='h3'>Endpoints</Header>
        </Segment>
        <Grid stackable columns={3}>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='blue'
                  name='globe'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>SIP Gateway</Header.Content>
                <Header.Subheader>
                  Deliver SIP trunks to authorised IP addresses
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(SIP_GATEWAY)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='blue'
                  name='globe'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>SIP Extension</Header.Content>
                <Header.Subheader>
                  Deliver to extensions via SIP Gateways
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(SIP)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='blue'
                  name='user'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>MS Teams</Header.Content>
                <Header.Subheader>
                  Deliver to MS Teams endpoint or group
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(TEAM)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='blue'
                  name='group'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Hunt Group</Header.Content>
                <Header.Subheader>
                  Deliver to a group of endpoints
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(HUNT_GROUP)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='blue'
                  name='phone'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Remote Destination</Header.Content>
                <Header.Subheader>
                  Deliver to an off platform endpoint
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(REMOTE)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='blue'
                  name='list'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Queue</Header.Content>
                <Header.Subheader>
                  Stack calls by delivering to a Queue
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(QUEUE)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
        </Grid>

        <Segment>
          <Header as='h3'>Routing</Header>
        </Segment>
        <Grid stackable columns={4}>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='green'
                  name='calendar alternate'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Date Range Router</Header.Content>
                <Header.Subheader>
                  Route calls based on date range
                </Header.Subheader>
              </Header>
              <Button
                inverted
                secondary
                onClick={() => select(DATE_RANGE_ROUTER)}
              >
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='green'
                  name='calendar alternate'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Time Range Router</Header.Content>
                <Header.Subheader>
                  Route calls based on time range
                </Header.Subheader>
              </Header>
              <Button
                inverted
                secondary
                onClick={() => select(TIME_RANGE_ROUTER)}
              >
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='green'
                  name='sliders'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>DNIS Router</Header.Content>
                <Header.Subheader>
                  Route calls based on dialled number
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(DNIS_ROUTER)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='green'
                  name='sliders'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>ANI Router</Header.Content>
                <Header.Subheader>
                  Route calls based on caller number
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(ANI_ROUTER)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='green'
                  name='sliders'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Zone Router</Header.Content>
                <Header.Subheader>
                  Route calls based on global zone
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(ZONE_ROUTER)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='green'
                  name='sliders'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Digits</Header.Content>
                <Header.Subheader>
                  Provide caller options and wait for digit press
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(NUMBER_PLAN)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='green'
                  name='plug'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Plugin</Header.Content>
                <Header.Subheader>
                  Hook into 3rd party integration for call control
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(PLUGIN)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment placeholder>
              <Header as='h3' icon textAlign='center'>
                <Icon
                  color='green'
                  name='code'
                  circular
                  // style={{ color: "#434bd9" }}
                />
                <Header.Content>Script</Header.Content>
                <Header.Subheader>
                  Use javascript to control the call flow
                </Header.Subheader>
              </Header>
              <Button inverted secondary onClick={() => select(SCRIPT)}>
                Add
              </Button>
            </Segment>
          </Grid.Column>
        </Grid>
      </Fragment>
    </Container>
  );
};

export default DeviceTypes;
